// Функция для рекурсивного обновления ID всех вложенных элементов
export const generateUniqueIds = (block) => {
  if (!block || typeof block !== 'object') return block;
  
  const newBlock = { ...block };
  
  // Создаем новый уникальный ID для текущего блока
  if (newBlock.id) {
    newBlock.id = Date.now().toString() + '_' + Math.random().toString(36).substr(2, 9);
  }
  
  // Обрабатываем вложенные элементы в зависимости от типа блока
  if (newBlock.type === 'columns' || newBlock.type === 'columns-3') {
    newBlock.data = { ...newBlock.data };
    
    if (newBlock.data.columns === 2) {
      // Двухколоночный layout
      if (newBlock.data.leftContent && Array.isArray(newBlock.data.leftContent)) {
        newBlock.data.leftContent = newBlock.data.leftContent.map(item => generateUniqueIds(item));
      }
      if (newBlock.data.rightContent && Array.isArray(newBlock.data.rightContent)) {
        newBlock.data.rightContent = newBlock.data.rightContent.map(item => generateUniqueIds(item));
      }
    } else {
      // Трехколоночный layout
      if (newBlock.data.content && Array.isArray(newBlock.data.content)) {
        newBlock.data.content = newBlock.data.content.map(column => {
          if (Array.isArray(column)) {
            return column.map(item => generateUniqueIds(item));
          }
          return column;
        });
      }
    }
  } else if (newBlock.type === 'container') {
    // Контейнер с одной колонкой
    newBlock.data = { ...newBlock.data };
    if (newBlock.data.content && Array.isArray(newBlock.data.content)) {
      newBlock.data.content = newBlock.data.content.map(item => generateUniqueIds(item));
    }
  }
  
  return newBlock;
};

// Функция для глубокого клонирования данных блока
export const deepCloneBlockData = (data) => {
  if (!data) return data;
  
  try {
    return JSON.parse(JSON.stringify(data));
  } catch (error) {
    console.error('Error deep cloning block data:', error);
    return data;
  }
};

// Функция для создания дубликата блока с уникальными ID
export const duplicateBlockWithUniqueIds = (block) => {
  if (!block) return block;
  
  // Сначала создаем глубокую копию данных
  const clonedBlock = {
    ...block,
    data: deepCloneBlockData(block.data)
  };
  
  // Затем генерируем уникальные ID для всех вложенных элементов
  return generateUniqueIds(clonedBlock);
};

const NESTED_CONTENT_KEYS = ['content', 'leftContent', 'rightContent'];

const getNestedChildren = (block) => {
  if (!block?.data) return [];
  const children = [];
  for (const key of NESTED_CONTENT_KEYS) {
    const value = block.data[key];
    if (!value) continue;
    if (Array.isArray(value) && value.length && Array.isArray(value[0])) {
      value.forEach((column) => {
        if (Array.isArray(column)) children.push(...column);
      });
    } else if (Array.isArray(value)) {
      children.push(...value);
    }
  }
  return children;
};

/** Find a block by id anywhere in the tree (canvas or nested columns/containers). */
export const findBlockById = (blocks, targetId) => {
  if (!Array.isArray(blocks) || !targetId) return null;

  for (const block of blocks) {
    if (block.id === targetId) return block;
    for (const child of getNestedChildren(block)) {
      const found = findBlockById([child], targetId);
      if (found) return found;
    }
  }
  return null;
};

/** Keep unsubscribe block pinned to the end of the list. */
export const ensureUnsubscribeLast = (blocks) => {
  const regular = blocks.filter((b) => b.type !== 'unsubscribe');
  const unsubscribe = blocks.filter((b) => b.type === 'unsubscribe');
  const ordered = [...regular, ...unsubscribe];
  return ordered.map((block, index) => ({ ...block, position: index }));
};

/** Normalize legacy hero block data shapes to the current schema. */
export const normalizeHeroData = (data = {}) => {
  const button = data.button || {};
  return {
    ...data,
    subtitle: data.subtitle || data.description || '',
    buttonText: data.buttonText ?? button.text ?? 'Get Started',
    buttonLink: data.buttonLink ?? button.link ?? '#',
    showButton: data.showButton ?? button.show ?? true,
    titleFontSize: data.titleFontSize ?? data.titleSize ?? 32,
    descriptionFontSize: data.descriptionFontSize ?? data.subtitleSize ?? 18,
    textAlign: data.textAlign ?? data.alignment ?? 'center',
  };
}; 